import React from 'react';
import { Zap, Activity, Target, Rocket, Brain, Trophy, Gift } from 'lucide-react';
const bonuses = [{
  title: 'BONO 1 — Agilidad y Cambios de Dirección',
  subtitle: '⚡ Cómo reaccionar más rápido y ganar ventaja física (25–40 páginas)',
  icon: Zap,
  image: 'https://cdn.magicpatterns.com/uploads/bqQ1sa3a5GD21rVMnZrN5w/image.png',
  items: ['Drills de reacción', 'Escalera de coordinación', 'Cambios de dirección', 'Salidas explosivas', 'Trabajo de pies', 'Agilidad con pelota']
}, {
  title: 'BONO 2 — Cómo Entrenar Durante el Período',
  subtitle: '🩸 Rendimiento femenino y adaptación inteligente (25–40 páginas)',
  icon: Activity,
  image: 'https://cdn.magicpatterns.com/uploads/hoCWwtaWYJFqf3R2UuFPFG/image.png',
  items: ['Adaptación de cargas', 'Nutrición', 'Energía y recuperación', 'Síntomas frecuentes', 'Planificación inteligente']
}, {
  title: 'BONO 3 — Técnica Profesional de Pase',
  subtitle: '🎯 Cómo pasar con precisión y velocidad (25–40 páginas)',
  icon: Target,
  image: 'https://cdn.magicpatterns.com/uploads/sCEdcFFnZMDXL7mfEZ8mef/image.png',
  items: ['Pase corto', 'Pase largo', 'Pase filtrado', 'Juego de primera', 'Técnica corporal']
}, {
  title: 'BONO 4 — Técnica de Tiro y Finalización',
  subtitle: '🚀 Cómo definir con potencia y seguridad (25–40 páginas)',
  icon: Rocket,
  image: 'https://cdn.magicpatterns.com/uploads/uTsS79qDfDdRGx5DbWonvR/image.png',
  items: ['Remates', 'Definiciones rápidas', 'Finalización en movimiento', 'Técnica corporal', 'Correcciones frecuentes']
}, {
  title: 'BONO 5 — Psicología Deportiva',
  subtitle: '🧠 Cómo controlar nervios y jugar con personalidad (25–40 páginas)',
  icon: Brain,
  image: 'https://cdn.magicpatterns.com/uploads/bUh9Bud7ithKwW7GiGs3fe/image.png',
  items: ['Inseguridad competitiva', 'Miedo a fallar', 'Concentración', 'Confianza corporal', 'Rutinas mentales']
}, {
  title: 'BONO 6 — Mentalidad de Alto Rendimiento',
  subtitle: '🔥 Cómo desarrollar disciplina, intensidad y mentalidad fuerte (25–40 páginas)',
  icon: Trophy,
  image: 'https://cdn.magicpatterns.com/uploads/6gKpWGaxKTMbsZ5NMBWjcp/image.png',
  items: ['Hábitos de atletas competitivas', 'Liderazgo', 'Motivación', 'Disciplina', 'Intensidad competitiva']
}];
export function Bonuses() {
  return <section className="py-20 bg-brand-dark text-white px-4" data-id="element-11">
      <div className="max-w-6xl mx-auto" data-id="element-12">
        <div className="text-center mb-16" data-id="element-13">
          <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-brand-pink/15 text-brand-pink mb-6" data-id="element-14">
            <Gift className="w-8 h-8" data-id="element-15" />
          </div>
          <h2 className="text-3xl md:text-5xl font-black uppercase tracking-tight mb-4" data-id="element-16">
            Llevate estos{' '}
            <span className="text-brand-pink" data-id="element-17">6 BONOS GRATIS</span>
          </h2>
          <p className="text-base md:text-xl font-bold text-zinc-200 bg-zinc-900 border border-zinc-800 inline-block px-6 py-2 rounded-full" data-id="element-18">
            Solo por el día de hoy
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-id="element-19">
          {bonuses.map((bono, i) => {
          const Icon = bono.icon;
          return <a key={i} href="https://checkout.ebookpoint.shop/cart/59567230648401:1" target="_blank" rel="noopener noreferrer" className="block bg-zinc-900 border-2 border-zinc-800 rounded-2xl overflow-hidden hover:border-brand-pink hover:shadow-[0_10px_30px_rgba(255,0,128,0.2)] transition-all duration-300 group cursor-pointer" data-id="element-20">
                {bono.image ? <div className="relative w-full h-44 overflow-hidden bg-zinc-950" data-id="element-21">
                    <img src={bono.image} alt={bono.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" data-id="element-22" />
                    {/* Gradient fade to card background */}
                    <div className="absolute inset-x-0 bottom-0 h-2/3 bg-gradient-to-t from-zinc-900 via-zinc-900/70 to-transparent pointer-events-none" data-id="element-23"></div>
                    <div className="absolute inset-0 bg-zinc-900/20 group-hover:bg-zinc-900/0 transition-colors duration-300 pointer-events-none" data-id="element-24"></div>
                  </div> : null}

                <div className="p-6" data-id="element-25">
                  <div className="w-12 h-12 rounded-xl bg-brand-pink/15 flex items-center justify-center text-brand-pink mb-5 group-hover:scale-110 transition-transform" data-id="element-26">
                    <Icon className="w-6 h-6" data-id="element-27" />
                  </div>
                  <h3 className="text-xl font-black uppercase mb-2 text-white group-hover:text-brand-pink transition-colors" data-id="element-28">
                    {bono.title}
                  </h3>
                  <p className="text-zinc-400 font-medium mb-4 text-sm" data-id="element-29">
                    {bono.subtitle}
                  </p>
                  <ul className="space-y-2" data-id="element-30">
                    {bono.items.map((item, j) => <li key={j} className="flex items-center gap-2 text-sm text-zinc-300 font-medium" data-id="element-31">
                        <div className="w-1.5 h-1.5 rounded-full bg-brand-pink shrink-0" data-id="element-32"></div>
                        {item}
                      </li>)}
                  </ul>
                </div>
              </a>;
        })}
        </div>
      </div>
    </section>;
}